import React from "react";

function Question({ question, answer }: { question: string; answer: string }) {
  return (
    <div>
      <p className="text-xl font-bold text-gray-900 sm:text-2xl font-pj">
        {question}
      </p>
      <p className="mt-3 text-base font-normal text-gray-600 sm:mt-6 sm:text-lg font-pj">
        {answer}
      </p>
    </div>
  );
}

export default Question;
